const initialFriends = [
  {
    id: 118836,
    name: 'Darko',
    image: process.env.PUBLIC_URL + '/imgs/darko.png',
    balance: -700,
  },
  {
    id: 933372,
    name: 'Misaki',
    image: process.env.PUBLIC_URL + '/imgs/misaki.png',
    balance: 200,
  },
  {
    id: 499476,
    name: 'Leon',
    image: process.env.PUBLIC_URL + '/imgs/leon.png',
    balance: 0,
  },
];

export default initialFriends;
